export default {
  genres: 'Жанры',
  artists: 'Исполнители',
  albums: 'Альбомы',
  tracks: 'Треки',
  playlist: 'Плейлист',
  playlists: 'Плейлисты',
  unknown_artist: 'Неизвестный исполнитель',
  unknown_album: 'Неизвестный альбом',
  unknown_track: 'Неизвестный трек',
  unknown_playlist: 'Неизвестный плейлист',

  clear: 'Очистить',
  download: 'Скачать',
  order_number: 'Отсортировать',
  shuffle: 'Перемешать',
  undo: 'Отменить',
  redo: 'Вернуть',

  browser_no_support: 'Данный браузер не поддерживает audio HTML',

  playlist_prompt: 'Название плейлиста (username:playlist_name)',
  random_playlist: 'Сгенерировать плейлист',
  all_apologies: 'Простите, это пока не работает',

  artists_alphabet: 'А-Я',
  recent_artists: 'Недавно добавленные',

  skin_purple: 'Фиолетовый',
  skin_green: 'Зелёный',
  skin_dark: 'Тёмный',
}